import Vue from "vue";
import Router from "vue-router";
import Website from "@/components/Website";
import Productintr from "@/components/Productintr";
import Aboutus from "@/components/Aboutus";
import Caseinfo from "@/components/Caseinfo";
import Contantus from "@/components/Contantus";
import qrCodeInformation from "@/components/qrCodeInformation";
import maintainRecord from "@/components/maintainRecord";
import repairRecord from "@/components/repairRecord";
import changerepairRecord from "@/components/changerepairRecord";
import elevator from "@/components/elevator";
import maintainDetail from "@/components/maintainDetail";
import elevmonitor from "@/components/elevmonitor";
Vue.use(Router);

export default new Router({
  mode: "hash", //history，hash
  routes: [
    {
      path: "/",
      name: "首页",
      component: Website
    },
    {
      path: "/productintr",
      name: "产品介绍",
      component: Productintr
    },
    {
      path: "/aboutus",
      name: "联系我们",
      component: Aboutus
    },
    {
      path: "/caseinfo",
      name: "业绩案例",
      component: Caseinfo
    },
    {
      path: "/contantus",
      name: "联系我们",
      component: Contantus
    },
    {
      path: "/elevator-detail",
      name: "二维码信息展示",
      component: qrCodeInformation
    },
    {
      path: "/elevator",
      name: "电梯信息",
      component: elevator
    },
    {
      path: "/maintainRecord",
      name: "维保记录",
      component: maintainRecord
    },
    {
      path: "/maintainDetail",
      name: "维保详情",
      component: maintainDetail
    },
    {
      path: "/repairRecord",
      name: "维修记录",
      component: repairRecord
    },
    {
      path: "/changerepairRecord",
      name: "换件记录",
      component: changerepairRecord
    },
    {
      path: "/monitor",
      name: "智能监测",
      component: elevmonitor
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js